import React from "react";

import styles from "./Eyebrow.module.scss";

const Eyebrow = ({ eyebrow }) => (
	<span className={styles.eyebrow}>{eyebrow}</span>
);

export default Eyebrow;
